import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Typography, LinearProgress } from '@mui/material'
import UserSearch from '../../components/UserSearch'
import { getUser } from '../../utils/util'
import { project as p } from '../../io/project/actions'
import { listAllMembers } from '../../services/graphql'
import { useSnackbar } from '../snackbar/context/SnackbarContext'

function ProjectTeam(props) {
  const [loading, setLoading] = useState(false)

  const { showSnackbar } = useSnackbar()

  const { project } = props

  useEffect(() => {
    if (project.team && project.team.id) {
      loadMoreMembers()
    }
  }, [])

  const loadMoreMembers = () => {
    setLoading(true)
    listAllMembers(project.team.id)
      .then((r) => {
        props.setTeam({ ...project.team, members: { items: r.members } })
        setLoading(false)
      })
      .catch((e) => {
        console.log(e)
        setLoading(false)
        showSnackbar({
          message: 'Error getting Members.',
          type: 'error'
        })
      })
  }

  return (
    <div style={{ padding: '1rem' }}>
      <Typography variant="h5" sx={{ textAlign: 'left', marginBottom: 1 }}>
        Team
      </Typography>
      {!loading ? (
        <Typography variant="subtitle1" sx={{ textAlign: 'left', marginBottom: 1 }}>
          {project.team.name}
        </Typography>
      ) : (
        <LinearProgress color="secondary" />
      )}
      {project.team && project.team.id && (
        <UserSearch
          team={project.team}
          loading={loading}
          loadMoreItems={loadMoreMembers}
          notDelete={
            project.team &&
            !project.team.user &&
            project.team.user &&
            getUser().id !== project.team.user.id
          }
        />
      )}
    </div>
  )
}

const mapDispatchToProps = {
  setTeam: p.setProjectTeam
}

const mapStateToProps = (state) => ({
  project: state.project
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTeam)
